$(function(){
  $(".batsu").click(function(){
    $("div").remove(".toolbar");
  });
});


// $(function () {
//   $(window).on('scroll', function () {
//       if ($('.section_top').height() < $(this).scrollTop()) {
//           $('.js-header').addClass('change-color');
//     } else {
//           $('.js-header').removeClass('change-color');
//     }
//   });
// });

$(window).on('scroll', function (){

  var box = $('.fadeIn');
  var animated = 'animated';
  
  box.each(function(){
  
    var boxOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    //画面内のどの位置で処理を実行するかで「100」の値を変更
    if(scrollPos > boxOffset - wh + 100 ){
      $(this).addClass(animated);
    }
  });

});

// アンカーリンク移動
$(function(){
    $('a[href^=#]').click(function() {
        var speed = 500; // スクロール速度(ミリ秒)
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $('html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });
});

// アコーディオン
$(function () {
$('.ac-parent').on('click', function () {
    $(this).next().slideToggle();
    //openクラスをつける
    $(this).toggleClass("open");
    //クリックされていないac-parentのopenクラスを取る
    $('.ac-parent').not(this).removeClass('open');

    // 一つ開くと他は閉じるように
    $('.ac-parent').not($(this)).next('.ac-child').slideUp();
});
});


